module.exports = __webpack_public_path__ + "static/media/PainDiscomfort.738cd6c5.png";